import {
  Drawer,
  Grid,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import React from "react";
import CloseIcon from "../../../icons/CloseIcon";
import StoreDtl from "./StoreDtl";
import useStyles from "../styles";

const ViewStore = ({ store, onClose, onChange }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Drawer
      open={true}
      onClose={onClose}
      anchor={isMobile ? "bottom" : "right"}
      className={classes.drawer}
    >
      <Grid container style={{ position: "relative" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontWeight: 700,
              fontSize: 20,
              marginTop: -10,
              wordBreak: "break-word",
              paddingRight: 16,
            }}
          >
            {store.store_name}
          </p>
          <IconButton
            aria-label="Close"
            aria-haspopup="true"
            color="inherit"
            onClick={onClose}
            style={{ marginTop: -26, outline: "none" }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
        <StoreDtl store={store} onChange={onChange} />
      </Grid>
    </Drawer>
  );
};

export default ViewStore;
